/**
 * Return landing page for param
 * @returns {String} - landing page (current location excluding query params and url hash)
 */
export default function getLandingPage() {
	return window.location.protocol + '//' + window.location.hostname + window.location.pathname;
}
